import { Accessor, AccessorFunction } from '../core/Chart.types';

export const resolveAccessor = <Datum, R>(accessor: Accessor<Datum, R>): AccessorFunction<Datum, R> =>
  typeof accessor === 'function' ? accessor : (datum: Datum) => datum[accessor] as R;
